import { disabledCursorMixin } from "./disabledCursorMixin";
import { disabledOpacityMixin } from "./disabledOpacityMixin";
/** @mixin disabledMixin */

/**
 * Adds disabled opacity and cursor styling to a component.
 *
 * @example
 * import { disabledMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${disabledMixin}
 * `;
 *
 * <Component>My component with regular styling</Component>
 * <Component disabled>My component with disabled styling</Component>
 *
 * @method
 * @param props {object}
 * @param {boolean} [props.disabled=false] - Renders the disabled styling.
 * @return {CSSObject}
 */

export var disabledMixin = function disabledMixin(props) {
  return [disabledCursorMixin(props), disabledOpacityMixin(props)];
};